export enum RoutingConstants {
  Login = "Login",
  Home  = "Home",
  Hunting = "Hunting",
  Fishing = "Fishing"
}
